import * as React from 'react';
import { NAVOrder } from '../models/interfaces';

interface OrderRowProps {
  order: NAVOrder;
}

interface OrderRowState {
  showProducts: boolean;
}

class OrderRow extends React.Component<OrderRowProps, OrderRowState> {
  constructor(props: OrderRowProps) {
    super(props);
    this.state = {
      showProducts: false
    };
  }

  render() {
    const { order } = this.props;
    return(
      <div
        className="row row--content"
        key={order.OrderId}
        onClick={() => this.setState({ showProducts: !this.state.showProducts })}
      >
        <div className="cell">{order.OrderDate}</div>
        <div className="cell">{order.Name}</div>
        <div className="cell">{order.ShipAddr1}</div>
        <div className="cell">{order.ShipZip}</div>
        <div className="cell">{order.ShipCity}</div>
      </div>
    );
  }
}

export default OrderRow;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/OrderRow.tsx